import View from './view';
import React from 'react';
import {IOwnProps} from './model';
import {dateFormats} from '../../../../../shared/constants/date';
import {useIsDesktop} from '../../../../../shared/hooks/useIsDesktop';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {formatHolderName} from '../../../../../shared/pipes';
import {datePipe} from '../../../../../shared/pipes/date';
import {capitalize} from '../../../../../shared/utils/text';

export const ProfileApplicationsItem: React.FC<IOwnProps> = ({application}) => {
  const isDesktop = useIsDesktop();
  const profile = useSelector(holderProfileSelector());

  return React.createElement(View, {
    subjects: [
      {
        label: 'ФИО',
        value: formatHolderName(profile),
      },
      {
        label: 'Основание',
        value: capitalize(application?.typeApplicationName),
      },
      {
        label: 'Дата подачи',
        value: datePipe(application?.dateTimeFiling),
      },
    ],
    historyTable: [
      ['Дата и время', 'Статус', 'Примечание'],
      ...(application?.statusHistory?.map((status) => [
        datePipe(status.date, dateFormats.fullDateWithTime) || '',
        status.statusName || '',
        status.note || '',
      ]) || []),
    ].map((row) => {
      if (!isDesktop) {
        row.length = 2;
      }

      return row;
    }),
    statusId: application?.statusId,
    statusName: application?.statusName,
    application,
  });
};
